import { LearningPathResponseApi } from "../../ServerResponseType/LearningPath/LearningPath";
import {
  LearningPathModuleRequestApi,
  LearningPathModuleRequestImpl,
} from "./LearningPathModuleRequest";
import {
  LearningPathResourceRequestApi,
  LearningPathResourceRequestImpl,
} from "./LearningPathResourceRequest";

export interface LearningPathRequestApi {
  learningPathId: string;
  learningPathName: string;
  learningPathModules: LearningPathModuleRequestApi[];
  learningPathResources: LearningPathResourceRequestApi[];
}

export class LearningPathRequestImpl implements LearningPathRequestApi {
  learningPathId: string;
  learningPathName: string;
  learningPathModules: LearningPathModuleRequestApi[];
  learningPathResources: LearningPathResourceRequestApi[];

  constructor(learningPath: LearningPathResponseApi) {
    this.learningPathId = learningPath.learningPathId;
    this.learningPathName = learningPath.learningPathName;
    this.learningPathModules = learningPath.learningPathModules.map(
      (learningPathModule) =>
        new LearningPathModuleRequestImpl(learningPathModule)
    );
    this.learningPathResources = learningPath.learningPathResources.map(
      (learningPathResource) =>
        new LearningPathResourceRequestImpl(learningPathResource)
    );
  }
}
